// extracted by mini-css-extract-plugin
module.exports = {"link":"ScrollLink_link__2WnDx","active":"ScrollLink_active__5dQNm"};